/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style5 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _style6 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style7 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style8 = require('antd/lib/tabs/style');

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.less');

var _tool = require('../../../utils/tool');

var _config = require('../../../utils/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPane = _tabs2.default.TabPane;

var _ref2 = (0, _jsx3.default)('span', {
    className: 'bat'
}, void 0, '\u7535\u6C60');

var BatDetail = function (_Component) {
    (0, _inherits3.default)(BatDetail, _Component);

    function BatDetail(props) {
        (0, _classCallCheck3.default)(this, BatDetail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BatDetail.__proto__ || (0, _getPrototypeOf2.default)(BatDetail)).call(this, props));

        _this.state = {
            /*详情*/
            detail: {
                batteryNumber: "",
                createTime: "",
                delflag: '-',
                hardwareCode: "",
                highestTemperature: '-',
                highestTemperatureNum: '-',
                highestVoltage: '-',
                highestVoltageNum: "0",
                lastModifyTime: "",
                lowestTemperature: '-',
                lowestTemperatureNum: "0",
                lowestVoltage: '-',
                lowestVoltageNum: "0",
                soc: "0",
                soh: "0",
                specs: "-",
                status: 1,
                totalVoltage: '-',
                type: 2
            },
            /*------------------------------------------*/
            batteryNumber: _this.props.params.bid,
            p1: {
                PageSize: 10,
                current: 1,
                // showSizeChanger:true,
                showQuickJumper: true,
                total: 0,
                showTotal: function showTotal(total) {
                    return '\u5171 ' + total + ' \u6761';
                }
            },
            p2: {
                PageSize: 10,
                current: 1,
                // showSizeChanger:true,
                showQuickJumper: true,
                total: 0,
                showTotal: function showTotal(total) {
                    return '\u5171 ' + total + ' \u6761';
                }
            },
            dataSource: [],
            dataSourceT: []
        };
        console.log(_this.props);
        return _this;
    }

    (0, _createClass3.default)(BatDetail, [{
        key: 'callback',
        value: function callback(e) {
            e === '1' ? this.handleReplaceList() : this.handleUseList();
        }

        /*2019.8.21*/

    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.handleDetail();
            this.handleReplaceList();
            this.handleUseList();
        }
        /*详情*/

    }, {
        key: 'handleDetail',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var _this2 = this;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _tool.http)(_config.apiJson.getOneBaseBatteryInfo, {
                                    batteryNumber: this.state.batteryNumber
                                }).then(function (res) {
                                    console.log(res, '----------');
                                    _this2.state.detail = res || {};
                                }).catch(function (res) {
                                    var msg = !res.errmsg ? '' + res : res.errmsg;
                                    message.error(msg);
                                });

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function handleDetail() {
                return _ref.apply(this, arguments);
            }

            return handleDetail;
        }()
        /*换电记录*/

    }, {
        key: 'handleReplaceList',
        value: function handleReplaceList() {
            var _this3 = this;

            (0, _tool.http)(_config.apiJson.getPageBatteryRecordList, {
                batteryNumber: this.state.batteryNumber,
                recordType: '1',
                page: this.state.p2.current,
                rows: this.state.p2.PageSize
            }).then(function (res) {
                console.log(res, '换电');
                var rows = res.rows || [];
                _this3.setState({
                    dataSource: rows,
                    p1: {
                        total: res.total
                    }
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? '' + res : res.errmsg;
                message.error(msg);
            });
        }
        /*使用记录*/

    }, {
        key: 'handleUseList',
        value: function handleUseList() {
            var _this4 = this;

            (0, _tool.http)(_config.apiJson.getPageBatteryRecordList, {
                batteryNumber: this.state.batteryNumber,
                recordType: '2',
                page: this.state.p1.current,
                rows: this.state.p1.PageSize
            }).then(function (res) {
                console.log(res, '使用');
                var rows = res.rows || [];
                _this4.setState({
                    dataSourceT: rows,
                    p2: {
                        total: res.total
                    }
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? '' + res : res.errmsg;
                message.error(msg);
            });
        }

        /*换电分页*/

    }, {
        key: 'handlePageReplace',
        value: function handlePageReplace(current) {
            var _this5 = this;

            (0, _tool.http)(_config.apiJson.getPageBatteryRecordList, {
                page: current.current,
                rows: current.pageSize,
                recordType: '1',
                batteryNumber: this.state.batteryNumber

            }).then(function (res) {
                var rows = res.rows || [];
                _this5.setState({
                    dataSource: rows,
                    p1: {
                        total: res.total
                    }
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? '' + res : res.errmsg;
                Message.error(msg);
            });
        }
        /*使用分页*/

    }, {
        key: 'handlePageUse',
        value: function handlePageUse(current) {
            var _this6 = this;

            (0, _tool.http)(_config.apiJson.getPageBatteryRecordList, {
                page: current.current,
                rows: current.pageSize,
                recordType: '2',
                batteryNumber: this.state.batteryNumber
            }).then(function (res) {
                var rows = res.rows || [];
                _this6.setState({
                    dataSourceT: rows,
                    p2: {
                        showQuickJumper: true,
                        showTotal: function showTotal(total) {
                            return '\u5171 ' + total + ' \u6761';
                        },
                        total: res.total
                    }
                });
            }).catch(function (res) {
                var msg = !res.errmsg ? '' + res : res.errmsg;
                message.error(msg);
            });
        }
        /*----------------------------------------------------------*/

    }, {
        key: 'render',
        value: function render() {
            var detail = this.state.detail;

            var dataOne = [{
                name: 'SOC',
                datas: detail.soc
            }, {
                name: 'SOH',
                datas: detail.soh
            }, {
                name: '当前状态',
                datas: detail.status === 1 ? '换电中' : '使用中'
            }, {
                name: '充电次数',
                datas: detail.totalChargedTimes || 0
            }, {
                name: '首次使用',
                datas: detail.createTime
            }];
            var dataTwo = [{
                name: '最近使用时间',
                datas: detail.lastModifyTime
            }, {
                name: '电池规格',
                datas: detail.specs
            }, {
                name: '有线/无线充电',
                datas: detail.type === 1 ? '有线' : '无线'
            }, {
                name: '硬件代码',
                datas: detail.hardwareCode
            }, {
                name: 'SOC',
                datas: detail.soc
            }, {
                name: '外壳材质',
                datas: detail.shellMaterialName || ''
            }, {
                name: '电芯厂家',
                datas: detail.cellSupplierName || ''
            }];
            var dataThree = [{
                name: '电池组当前总电压（单位/V）',
                datas: detail.totalVoltage / 10
            }, {
                name: '最高单体电压（单位/V）',
                datas: detail.highestVoltage / 10
            }, {
                name: '最高单体电压编号',
                datas: detail.highestVoltageNum
            }, {
                name: '最低单体电压（单位/V）',
                datas: detail.lowestVoltage / 10
            }, {
                name: '最低单体电压编号',
                datas: detail.lowestVoltageNum
            }, {
                name: '电池组最高温度（单位/℃）',
                datas: detail.highestTemperature
            }, {
                name: '最高温度探头编号',
                datas: detail.highestTemperatureNum
            }, {
                name: '电池组低温度（单位/℃）',
                datas: detail.lowestTemperature
            }, {
                name: '最低温度探头编号',
                datas: detail.lowestTemperatureNum
            }];

            /*换电列表*/
            var columns = [{
                title: '序号',
                dataIndex: 'key',
                key: 'key',
                render: function render(text, record, index) {
                    return '' + (index + 1);
                }

            }, {
                title: '状态',
                dataIndex: '换电',
                key: 'recordType',
                render: function render(text, record) {
                    return '换电';
                }
            }, {
                title: '换电柜',
                dataIndex: 'serialNumber',
                key: 'serialNumber'
            }, {
                title: '用户',
                dataIndex: 'phone',
                key: 'phone'
            }, {
                title: '时间',
                dataIndex: 'createTime',
                key: 'createTime'
            }];
            /*使用列表*/
            var columnsT = [{
                title: '序号',
                dataIndex: 'key',
                key: 'key',
                render: function render(text, record, index) {
                    return '' + (index + 1);
                }

            }, {
                title: '状态',
                dataIndex: 'recordType',
                key: 'recordType',
                render: function render(text, record) {
                    return '使用';
                }
            }, {
                title: '车辆Vin',
                dataIndex: 'serialNumber',
                key: 'serialNumber'
            }, {
                title: 'VCU',
                dataIndex: 'vcu',
                key: 'vcu'
            }, {
                title: '用户',
                dataIndex: 'phone',
                key: 'phone'
            }, {
                title: '时间',
                dataIndex: 'createTime',
                key: 'createTime'
            }];
            return (0, _jsx3.default)('div', {
                className: 'batdetail'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'batdetail-header'
            }, void 0, _ref2, (0, _jsx3.default)('span', {}, void 0, this.state.batteryNumber)), (0, _jsx3.default)('div', {
                className: 'batdetail-detail'
            }, void 0, (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_row2.default, {
                type: 'flex'
            }, void 0, (0, _jsx3.default)(_col2.default, {
                span: 6,
                order: 1,
                offset: 2
            }, void 0, (0, _jsx3.default)('div', {
                className: 'batdetail-battery'
            }, void 0, dataOne.map(function (res, i) {
                return (0, _jsx3.default)('p', {
                    className: 'batterydata'
                }, i, res.name, '\uFF1A', (0, _jsx3.default)('span', {}, void 0, res.datas));
            }))), (0, _jsx3.default)(_col2.default, {
                span: 8,
                order: 2
            }, void 0, (0, _jsx3.default)('div', {
                className: 'batdetail-basic'
            }, void 0, dataTwo.map(function (res, i) {
                return (0, _jsx3.default)('p', {
                    className: 'topfive'
                }, i, res.name, '\uFF1A', (0, _jsx3.default)('span', {}, void 0, res.datas));
            }))), (0, _jsx3.default)(_col2.default, {
                span: 8,
                order: 3
            }, void 0, (0, _jsx3.default)('div', {
                className: 'batdetail-basic'
            }, void 0, dataThree.map(function (res, i) {
                return (0, _jsx3.default)('p', {
                    className: 'topfive'
                }, i, res.name, '\uFF1A', (0, _jsx3.default)('span', {}, void 0, res.datas));
            }))))), ','), (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)(_tabs2.default, {
                defaultActiveKey: '1',
                onChange: this.callback.bind(this)
            }, void 0, (0, _jsx3.default)(TabPane, {
                tab: '\u6362\u7535\u8BB0\u5F55'
            }, '1', (0, _jsx3.default)(_table2.default, {
                dataSource: this.state.dataSource,
                columns: columns,
                pagination: this.state.p1,
                onChange: this.handlePageReplace.bind(this)
            })), (0, _jsx3.default)(TabPane, {
                tab: '\u4F7F\u7528\u8BB0\u5F55'
            }, '2', (0, _jsx3.default)(_table2.default, {
                dataSource: this.state.dataSourceT,
                columns: columnsT,
                pagination: this.state.p2,
                onChange: this.handlePageUse.bind(this)
            })))));
        }
    }]);
    return BatDetail;
}(_react.Component);

exports.default = BatDetail;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/batteryManagement/batterydetail/index.jsx
// module id = 1581
// module chunks = 0